import React, { lazy } from 'react';
export function Footer() {
  return <footer className="bg-[#2a2a2a] text-white py-16 px-6 lg:px-8" data-id="element-85">
      <div className="max-w-[1100px] mx-auto flex flex-col md:flex-row justify-between items-center md:items-start gap-10 text-center md:text-left" data-id="element-86">
        <div className="max-w-md flex flex-col items-center md:items-start" data-id="element-87">
          <h2 className="text-2xl font-extrabold tracking-tight mb-4" data-id="element-88">
            APROBÁ EN SERIO™
          </h2>
          <p className="text-gray-400 text-sm leading-relaxed" data-id="element-89">
            El sistema de estudio N°1 para estudiantes universitarios y
            terciarios de Argentina. Porque aprobar no debería costarte la salud
            ni la cordura.
          </p>

          <div className="my-4 bg-white rounded-xl px-5 py-2 inline-flex" data-id="element-90">
            <img src="https://cdn.magicpatterns.com/uploads/uSKTb3WrqrPE4zzNLVUC3w/Diseno_sin_titulo_(1).png" alt="DigSol Logo" className="h-40 md:h-56 w-auto object-contain" loading="lazy" data-id="element-91" />
          </div>
        </div>

        <div className="flex flex-col gap-2 text-gray-300 text-sm mt-[-25px] mb-[-25px]" data-id="element-92">
          <a href="mailto:soportedigsol@gmail.com" className="hover:text-white transition-colors" data-id="element-93">
            soportedigsol@gmail.com
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-94">
            @digsol.shop
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-95">
            digsol.shop
          </a>
        </div>
      </div>

      <div className="max-w-[1100px] mx-auto mt-16 pt-8 border-t border-gray-800 text-center text-gray-500 text-xs" data-id="element-96">
        © digsol.shop™ 2026 — Todos los derechos reservados.
      </div>
    </footer>;
}